"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeCurrentUrl = void 0;
/**
 * Ensures that the current URL complies to RFC 3986.
 * (As sometimes this might not be the case in FF.)
 *
 * History and location objects could be provided as
 * the arguments. This is useful to have them mocked
 * in tests.
 *
 * @param {History} [history]   The history object
 * @param {Location} [location] The location object
 */
var normalizeCurrentUrl = exports.normalizeCurrentUrl = function normalizeCurrentUrl() {
  var history = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.history;
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;
  var originalUrl = location.toString();
  var normalizedUrl = encodeURI(decodeURI(originalUrl));
  if (originalUrl !== normalizedUrl) {
    history.replaceState(null, null, normalizedUrl);
  }
};
//# sourceMappingURL=url-utils.js.map